/*
 * @format
 */

import _ from 'lodash';
import timeout from '../utils/timeout';
import * as types from '../action-types';

const DEFAULT_DEBOUNCE_OPTIONS = {
  debounceEnabled: false,
  timeoutOverride: null,
};

// this is creating an action that can be dispatched.
// it'll be handled by the controls saga
export const superDebounce = (
  sendWsMessage,
  message,
  timeoutAction,
  expectedState,
  options = DEFAULT_DEBOUNCE_OPTIONS,
) => {
  const zoneId = Array.isArray(message.data.prtId)
    ? message.data.prtId[0]
    : message.data.prtId;
  const endpointId = Array.isArray(message.data.prtId)
    ? message.data.prtId[1]
    : message.data.endpointId;

  return {
    type: options.debounceEnabled
      ? types.DEBOUNCED_SEND_CONTROL
      : types.SEND_CONTROL,
    sendWsMessage,
    message,
    timeoutAction,
    homeId: message.data.siId || message.data.hpiId,
    zoneId,
    endpointId,
    expectedState,
    timeoutOverride: options.timeoutOverride,
  };
};

const throttledSend = _.debounce(async (dispatch, sendWsMessage, message) => {
  dispatch({ type: types.COMMAND_SENT, message });

  sendWsMessage(message);
}, 1000);

// when we don't want a message to send immediately, but needed the reducers effect to
// be seen we can use this. The start action can be done separately then this called
// to make sure the last update is sent out after a second of no new updates
export const debouncedSendAndTimeout = (
  sendWsMessage,
  message,
  timeoutAction,
  timeoutDuration,
) => {
  return async dispatch => {
    await throttledSend(dispatch, sendWsMessage, message);
    await timeout(timeoutDuration);
    dispatch(timeoutAction);
  };
};

export function debounceSendControl(
  sendWsMessage,
  message,
  timeoutAction,
  timeoutDuration,
) {
  return async dispatch => {
    await throttledSend(
      dispatch,
      sendWsMessage,
      message,
      timeoutAction,
      timeoutDuration,
    );

    await timeout(timeoutDuration);
    dispatch(timeoutAction);
  };
}

export function sendAndWaitForTimeout(sendWsMessage, message, timeoutAction) {
  return async dispatch => {
    dispatch({ type: types.COMMAND_SENT, message });

    sendWsMessage(message);
    await timeout();
    dispatch(timeoutAction);
  };
}

export function startDeviceServiceRequest(homeId, requestId, message) {
  return {
    type: types.DEVICE_SERVICE_REQUEST_STARTED,
    homeId,
    requestId,
    message,
  };
}
